import {
  required, minLength, maxLength, email, sameAs, numeric, helpers,
} from 'vuelidate/lib/validators';

const checked = sameAs(() => true);

export default {
  data() {
    return {
      value: '',
    };
  },
  props: {
    validators: {
      type: Array,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
    },
    required: {
      type: Boolean,
    },
  },
  watch: {
    name: {
      immediate: true,
      deep: true,
      handler() {
        this.value = '';
        this.$v.value.$reset();
      },
    },
  },
  validations() {
    const value = {};
    if (this.required) {
      value.required = required;
    }
    if (this.required && this.type === 'checkbox') {
      value.checked = checked;
    }
    if (this.type === 'email') {
      value.email = email;
    }
    if (!this.validators || this.validators === null || this.validators.length === 0) {
      return {
        value,
        panDigitsModel: {
          $each: {
            Digit: { numeric, required },
          },
        },
      };
    }
    let fieldValidator = this.findValidator(this.validators, 'minLength');
    if (fieldValidator) {
      value.minLength = minLength(fieldValidator.minLength);
    }
    fieldValidator = this.findValidator(this.validators, 'maxLength');
    if (fieldValidator) {
      value.maxLength = maxLength(fieldValidator.maxLength);
    }
    fieldValidator = this.findValidator(this.validators, 'regExp', this.selectedCountry);
    if (fieldValidator) {
      const pattern = new RegExp(fieldValidator.regExp);
      value.matchesRegex = helpers.regex(value, pattern);
    }
    return {
      value,
      panDigitsModel: {
        $each: {
          Digit: { numeric, required },
        },
      },
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
    maxLengthValidation() {
      return Object.prototype.hasOwnProperty.call(this.$v.value, 'maxLength') && this.$v.value.$dirty && !this.$v.value.maxLength;
    },
    minLengthValidation() {
      return Object.prototype.hasOwnProperty.call(this.$v.value, 'minLength') && this.$v.value.$dirty && !this.$v.value.minLength;
    },
    regexValidation() {
      return Object.prototype.hasOwnProperty.call(this.$v.value, 'matchesRegex') && this.$v.value.$dirty && !this.$v.value.matchesRegex;
    },
    emailInputType() {
      return this.type === 'email';
    },
  },
  methods: {
    containsError(value) {
      return this.$emit('fieldUpdated', value, this.$props.name);
    },
    findValidator(validatorsList, property, optionValue) {
      return validatorsList.find((element) => {
        const hasProperty = Object.prototype.hasOwnProperty.call(element, property);
        const hasOptionValue = optionValue ? element.optionValue === optionValue : true;
        return hasProperty && hasOptionValue;
      });
    },
    translate(multiLanguageLabel) {
      if (multiLanguageLabel) {
        const label = multiLanguageLabel.find((element) => { return element.language.code === this.currentLanguage; });
        if (label) {
          return label.text;
        }
        return multiLanguageLabel.find((element) => { return element.language.code === 'en'; }).text;
      }
      return '';
    },
  },
};
